import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import {
  ImageBlock,
  ContentBlock,
  ImageGroup,
  ImageGroupDetails,
  Asset,
} from "src/app/shared/model/container.models";
import { CommonHttpService } from "src/app/shared/services/common-http/common-http.service";
import { MessageService } from "src/app/shared/services/message/message.service";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { FileUploader, FileItem, ParsedResponseHeaders } from "ng2-file-upload";
import {
  imageGifAllowedExtension,
  serverUrl,
  Modalconfig,
  devicePixelRatio,
  DefaultLanguageId,
  linkPattern,
} from "src/app/shared/constants";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";
import { Observable, of, concat, Subject, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
  catchError,
} from "rxjs/operators";
import { AuthService } from "src/app/core/authentication/auth.service";
import { ConfirmationModelComponent } from "src/app/shared/components/confirmation-model/confirmation-model.component";
import {
  moveItemInArray,
  CdkDropListGroup,
  CdkDropList,
  CdkDrag,
} from "@angular/cdk/drag-drop";
import { ActivatedRoute } from "@angular/router";
import { PlaybookCommunicationService } from "../../services/playbook-communication.service";
import {
  clone,
  cloneDeep,
  findIndex,
  forEach,
  includes,
  reject,
  sortBy,
} from "lodash";
import { UtilitiesService } from "src/app/shared/services/utilities/utilities.service";

const URL = serverUrl + "/api/Assets/UploadImage";
@Component({
    selector: "app-add-image",
    templateUrl: "./add-image.component.html",
    styleUrls: ["./add-image.component.scss"],
    standalone: false
})
export class AddImageComponent implements OnInit {
  @ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) placeholder: CdkDropList;
  @ViewChild("fileInput") fileInput: ElementRef;
  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  sectionId: number;
  pageId: number;
  uploadedImg: string | ArrayBuffer = null;
  contentBlock: ContentBlock;
  showProgress = false;
  selectedPill = "link";
  playbookId = null;
  items: ImageGroup[];
  imageGroupDetails: ImageGroupDetails[];
  progressPercent = 0;
  isEnlarged = true;
  selectedFile: any;
  imgBlock: ImageBlock;
  uploadImageForm: UntypedFormGroup;
  editImageGroupForm: UntypedFormGroup;
  people3$: Observable<any[]>;
  people3Loading = false;
  people3input$ = new Subject<string>();
  isGroupEditable = false;
  submitted: boolean;
  selectedImageGroup: ImageGroup;
  uploader: FileUploader;
  disableEnlargeImage = false;
  enlargeImageValue: boolean;
  valueExist: boolean;
  confModalRef: BsModalRef;
  languageId: number;
  confModalSubsciber: Subscription;
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;
  defaultLanguageId = DefaultLanguageId;
  companyId: number;
  butonColor = "#000000";
  serverUrl = serverUrl;
  devicePixelRatio = devicePixelRatio;
  isdraftmode: boolean;
  pageTemplateId;
  openFromMobile: boolean;
  onclose = new Subject();
  constructor(
    private commonHttpService: CommonHttpService,
    private formBuilder: UntypedFormBuilder,
    private messageService: MessageService,
    private modalService: BsModalService,
    private authService: AuthService,
    private modalRef: BsModalRef,
    private activatedRoute: ActivatedRoute,
    private commService: PlaybookCommunicationService,
    private utilitiesService: UtilitiesService
  ) {
    this.target = null;
    this.source = null;
    this.fileUploader();
    this.createUploadImageForm();
  }

  ngOnInit() {
    this.languageId =
      +this.activatedRoute.snapshot.queryParams.languageId ||
      this.defaultLanguageId;
    this.companyId = this.commService.getCompanyId();
    this.playbookId = this.contentBlock.playbookId;
    this.submitted = false;
    this.editImageGroupForm = this.formBuilder.group({
      editImageGroupName: [
        null,
        [Validators.required, Validators.maxLength(200)],
      ],
    });
    this.getImageBlockData();
  }

  /**
   * method to get image block data
   */
  getImageBlockData() {
    this.submitted = false;
    this.loadPeople3();
    if (this.languageId !== this.defaultLanguageId) {
      this.commonHttpService
        .postWithHeaders(
          {
            uri: `/api/Translation/CreateImageBlockIfNotExists`,
            object: {
              playbookId: this.contentBlock.playbookId,
              companyId: this.companyId,
              languageId: this.languageId,
              contentBlockId: this.contentBlock.id,
            },
          },
          {
            pageId: this.pageId,
            sectionId: this.sectionId,
            playbookId: this.playbookId,
            languageId: this.languageId,
            isdraftmode: this.isdraftmode,
          }
        )
        .subscribe((response) => {
          if (response === "true") {
            this.commonHttpService
              .get<ImageBlock>({
                uri: `/api/Translation/GetImageBlockWithImageGroupForTranslation?playbookId=${this.playbookId}&companyId=${this.companyId}&languageId=${this.languageId}&contentBlockId=${this.contentBlock.id}`,
              })
              .subscribe((imageBlockResponse) => {
                this.imgBlock = imageBlockResponse;
                if (this.imgBlock) {
                  this.updateAllFormControls();
                }
              });
          } else {
            this.messageService.showErrorMessage(
              "something went wrong while fetching image group"
            );
          }
        });
    } else {
      this.imgBlock = clone(this.contentBlock.imageBlock);
      if (this.imgBlock) {
        this.updateAllFormControls();
      }
    }
  }
  /**
   * to initialize edit imageblock form
   */
  updateAllFormControls() {
    let imageGroupIndex = 0;
    if (this.pageTemplateId == null) {
      if (this.imgBlock.imageGroup && this.imgBlock.imageGroup.name) {
        imageGroupIndex = findIndex(
          this.items,
          (eachImageGroupIndex) =>
            eachImageGroupIndex.id === this.imgBlock.imageGroup.id
        );
      }
      this.uploadImageForm.patchValue({
        agree: this.items[imageGroupIndex]
          ? this.items[imageGroupIndex].name
          : "",
      });
      this.selectedImageGroup = this.items[imageGroupIndex]
        ? this.items[imageGroupIndex]
        : null;
      this.imageGroupDetails = this.items[imageGroupIndex]
        ? this.items[imageGroupIndex].imageGroupDetail
        : [];
    }

    this.uploadImageForm.patchValue({
      linkUrl: this.imgBlock.linkURL ? this.imgBlock.linkURL : null,
      enlargeImage: this.imgBlock.enableImageAction,
    });
  }

  //#region slideshow feature methods

  /**
   * method to select imageGroup to update images
   * @param selectedItem selected imageGroup from dropdown
   */
  another(selectedItem) {
    if (selectedItem) {
      this.selectedImageGroup = selectedItem;
      if (selectedItem.name && !selectedItem.id) {
        const reqObj = {
          name: selectedItem.name,
          playbookId: this.playbookId,
          languageId: this.languageId,
        };

        this.commonHttpService
          .postWithHeaders(
            {
              uri: "/api/ImageBlocks/AddImageGroup",
              object: reqObj,
            },
            {
              pageId: this.pageId,
              sectionId: this.sectionId,
              playbookId: this.playbookId,
              languageId: this.languageId,
              isdraftmode: this.isdraftmode,
            }
          )
          .subscribe(
            (response: ImageGroup) => {
              this.items = [...this.items, response];
              this.selectedImageGroup = response;
            },
            (err) => {
              console.log(err);
            }
          );
      }
      const imageGroupIndex = this.findImageGroupIndex(
        this.items,
        selectedItem.id
      );
      this.imageGroupDetails = selectedItem.imageGroupDetail
        ? imageGroupIndex !== -1
          ? this.items[imageGroupIndex].imageGroupDetail
          : []
        : [];
      this.imageGroupDetails = sortBy(this.imageGroupDetails, "order");
    } else {
      this.imageGroupDetails = [];
    }
  }

  get editImageGroupFormControl() {
    return this.editImageGroupForm.controls;
  }

  // To update group name
  setEditableGroupName() {
    this.isGroupEditable = true;
    this.editImageGroupForm.patchValue({
      editImageGroupName: this.selectedImageGroup.name,
    });
  }
  checkForValidGroupText(groupText) {
    return (
      groupText === undefined ||
      groupText === null ||
      groupText.toString().trim() === ""
    );
  }
  cancelGroupUpdate() {
    this.isGroupEditable = false;
  }

  /**
   * Method to remove image group
   * @param group Group to be deleted
   */
  deleteImageGroup(group) {
    const initialState = {
      msg: "Are you sure you would like to delete this slideshow? All images uploaded to this group will be removed.",
    };
    this.confModalRef = this.modalService.show(
      ConfirmationModelComponent,
      Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
    );
    this.confModalSubsciber = this.confModalRef.content.onclose.subscribe(
      (res) => {
        if (res) {
          const reqObj = {
            playbookId: this.contentBlock.playbookId,
            groupId: group.id,
            pageTemplateId: this.pageTemplateId,
            languageId: this.languageId,
          };
          this.commonHttpService
            .deleteWithBodyWithHeaders(
              {
                uri: "/api/ImageBlocks/DeleteImageGroup",
                object: reqObj,
              },
              {
                pageId: this.pageId,
                sectionId: this.sectionId,
                playbookId: this.playbookId,
                languageId: this.languageId,
                isdraftmode: this.isdraftmode,
              }
            )
            .subscribe((response) => {
              this.selectedImageGroup = null;
              this.imageGroupDetails = [];
              this.imgBlock.imageGroupId = null;
              this.imgBlock.imageGroup = null;
              this.contentBlock.imageBlock.imageGroup = null;
              this.contentBlock.imageBlock.imageGroupId = null;
              this.items = reject(this.items, (item) => {
                return item.id === group.id;
              });
              this.updateImageGroupDropdown();
              this.confModalRef.hide();
            });
        } else {
          this.confModalRef.hide();
        }
        this.confModalSubsciber.unsubscribe();
      }
    );
  }

  /**
   * method to handle deletion of image from image group
   * @param image image object to be deleted
   */
  deleteUploadedImage(image) {
    const reqObj = {
      playbookId: this.contentBlock.playbookId,
      imageGroupId: image.imageGroupId,
      imageId: image.id,
      languageId: this.languageId,
      PageTemplateId: this.pageTemplateId,
    };
    this.commonHttpService
      .deleteWithBodyWithHeaders(
        {
          uri: "/api/ImageBlocks/DeleteGroupImage",
          object: reqObj,
        },
        {
          pageId: this.pageId,
          sectionId: this.sectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          isdraftmode: this.isdraftmode,
        }
      )
      .subscribe((res: ImageGroup) => {
        this.selectedImageGroup = res;
        this.imageGroupDetails = res.imageGroupDetail;
        const imageGroupIndex = this.findImageGroupIndex(this.items, res.id);
        if (imageGroupIndex !== -1) {
          this.items[imageGroupIndex] = res;
        }
      });
  }

  /**
   * Method to update image group name
   */
  updateImageGroup() {
    this.submitted = true;
    if (this.editImageGroupForm.invalid) {
      return true;
    }
    const reqObj = {
      id: this.selectedImageGroup.id,
      name: this.editImageGroupForm.value.editImageGroupName,
      playbookId: this.playbookId,
      languageId: this.languageId,
    };
    this.selectedImageGroup.name =
      this.editImageGroupForm.value.editImageGroupName;
    this.commonHttpService
      .putWithHeaders(
        {
          uri: "/api/ImageBlocks/UpdateImageGroup",
          object: reqObj,
        },
        {
          pageId: this.pageId,
          sectionId: this.sectionId,
          playbookId: this.playbookId,
          languageId: this.languageId,
          isdraftmode: this.isdraftmode,
        }
      )
      .subscribe((response: ImageGroup) => {
        this.isGroupEditable = false;
        const imageGroupIndex = this.findImageGroupIndex(
          this.items,
          response.id
        );
        if (imageGroupIndex !== -1) {
          this.items[imageGroupIndex] = response;
        }
        this.updateImageGroupDropdown();
        this.submitted = false;
      });
  }

  /**
   * method to find and return index of group from list
   * @param imageGroupList imageGroup list
   * @param updatedImageGroupId imageGroup id for finding index from list
   */
  findImageGroupIndex(
    imageGroupList: ImageGroup[],
    updatedImageGroupId: number
  ) {
    return findIndex(imageGroupList, (imageGroup) => {
      return imageGroup.id === updatedImageGroupId;
    });
  }
  //#endregion slideshow feature methods

  handleEnalargeImageCheckbox(enlargeImageValue, disableEnlargeImageValue) {
    this.uploadImageForm.patchValue({
      enlargeImage: enlargeImageValue,
    });
    if (disableEnlargeImageValue) {
      this.enlargeImage.disable();
    } else {
      this.enlargeImage.enable();
    }
  }

  /**
   * method to upload image of image block
   * @param event image file to be uploaded
   */
  fileSelected(event) {
    this.selectedFile = event.target.files[0];
    const isValidExtension = this.validateExtension();
    if (isValidExtension) {
      const formData = new FormData() as any;
      this.showProgress = true;
      formData.append("file", this.selectedFile);
      this.commonHttpService
        .postWithProgress({
          uri: "/api/Assets/UploadImage",
          object: formData,
        })
        .subscribe((response: Asset | number) => {
          if (typeof response === "number") {
            this.progressPercent = response;
          } else if (response) {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(this.selectedFile);
            fileReader.onload = (e) => {
              this.uploadedImg = fileReader.result;
              this.imgBlock.assetId = response.id;
              this.imgBlock.asset = response;
              this.progressPercent = 0;
              this.showProgress = false;
            };
          }
        });
    } else {
      const initialState = {
        msg:
          "This is not a valid extension. Supported extensions are : " +
          imageGifAllowedExtension.join(",") +
          ".",
        showCancelBtn: false,
      };
      this.confModalRef = this.modalService.show(
        ConfirmationModelComponent,
        Object.assign({ initialState }, { class: "custom-modal" }, Modalconfig)
      );
      this.confModalSubsciber = this.confModalRef.content.onclose.subscribe(
        (res) => {
          this.confModalRef.hide();
          this.confModalSubsciber.unsubscribe();
        }
      );
    }
  }

  validateExtension() {
    const extensionArray = this.selectedFile.name.split(".");
    const extension = extensionArray[extensionArray.length - 1].toLowerCase();
    const isValidExtension = includes(imageGifAllowedExtension, extension);
    return isValidExtension;
  }

  updateImageGroupDropdown() {
    this.loadPeople3();
    this.uploadImageForm.patchValue({
      agree: this.selectedImageGroup ? this.selectedImageGroup.name : null,
    });
  }

  // Method to return groups having passed item name
  getPeople(term: string = null): Observable<any[]> {
    let itemsfound;
    if (term) {
      itemsfound = this.items.filter(
        (x) => x.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1
      );
    } else {
      itemsfound = this.items;
    }
    return of(itemsfound);
  }

  createUploadImageForm() {
    this.uploadImageForm = this.formBuilder.group({
      enlargeImage: [false],
      linkUrl: [null, [Validators.pattern(linkPattern)]],
      agree: [null],
    });
    this.onLinkChange();
  }

  // Method to update enlarge image checkdox on update of url
  onLinkChange() {
    this.linkUrl.valueChanges.subscribe((value) => {
      if (!this.valueExist) {
        this.enlargeImageValue = this.enlargeImage.value;
      }
      if (value) {
        this.valueExist = true;
        this.handleEnalargeImageCheckbox(true, true);
      } else {
        this.valueExist = false;
        this.handleEnalargeImageCheckbox(this.enlargeImageValue, false);
      }
    });
  }
  get form() {
    return this.uploadImageForm.controls;
  }
  get linkUrl() {
    return this.uploadImageForm.get("linkUrl");
  }
  get enlargeImage() {
    return this.uploadImageForm.get("enlargeImage");
  }
  get agree() {
    return this.uploadImageForm.get("agree");
  }

  // Method to handle search in group dropdown
  private loadPeople3() {
    this.people3$ = concat(
      of(this.items),
      this.people3input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.people3Loading = true)),
        switchMap((term: string) =>
          this.getPeople(term).pipe(
            catchError(() => of(["Something went wrong"])), // empty list on error
            tap(() => (this.people3Loading = false))
          )
        )
      )
    );
  }

  //#region multiple fileupload related code
  clearSlideShowImages() {
    if (this.fileInput) {
      this.fileInput.nativeElement.value = null;
    }
  }

  fileUploader() {
    this.uploader = new FileUploader({ url: URL });
    this.uploader.onErrorItem = (item, response, status, headers) =>
      this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) =>
      this.onSuccessItem(item, response, status, headers);
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = true;
      this.onFileChange();
    };
  }

  // Callback of upload image in multi loader
  onSuccessItem(
    item: FileItem,
    response: string,
    status: number,
    headers: ParsedResponseHeaders
  ): any {
    const result = JSON.parse(response).Result;
    if (status === 200) {
      const reqObj = {
        playbookId: this.contentBlock.playbookId,
        imageGroupId: this.selectedImageGroup.id,
        imageId: result.id,
        languageId: this.languageId,
      };
      this.commonHttpService
        .postWithHeaders(
          {
            uri: "/api/ImageBlocks/AddImageToImageGroup",
            object: reqObj,
          },
          {
            pageId: this.pageId,
            sectionId: this.sectionId,
            playbookId: this.playbookId,
            languageId: this.languageId,
            isdraftmode: this.isdraftmode,
          }
        )
        .subscribe((resp: ImageGroup) => {
          this.selectedImageGroup = resp;
          this.imageGroupDetails = this.selectedImageGroup.imageGroupDetail;
          const imageGroupIndex = this.findImageGroupIndex(this.items, resp.id);
          if (imageGroupIndex !== -1) {
            this.items[imageGroupIndex] = resp;
          }
        });
    }
  }
  onErrorItem(
    item: FileItem,
    response: string,
    status: number,
    headers: ParsedResponseHeaders
  ): any {}

  // Method to handle validation on images and uploading it
  onFileChange() {
    let fileUploadNotValidExtensions = 0;
    this.uploader.queue.map((item) => {
      // tslint:disable-next-line: no-string-literal
      if ((!item.isUploaded || item.isUploading) && !item["checked"]) {
        if (
          item.file.type.match(/image\/*/) != null &&
          imageGifAllowedExtension.indexOf(item.file.type.split("/").pop()) !==
            -1
        ) {
          this.uploader.setOptions({
            url: URL,
            authToken: this.authService.authorizationHeaderValue(),
            headers: [
              {
                name: "X-XSRF-TOKEN",
                value: this.utilitiesService.getCookie("XSRF-TOKEN"),
              },
            ],
            removeAfterUpload: false,
          });
          this.uploader.uploadItem(item);
        } else {
          fileUploadNotValidExtensions++;
        }
      }
      // tslint:disable-next-line: no-string-literal
      item["checked"] = true;
    });
    if (fileUploadNotValidExtensions) {
      this.messageService.showErrorMessage(
        "This is not a valid extension. Supported extensions are : " +
          imageGifAllowedExtension.join(",") +
          "."
      );
    }
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }
  //#endregion multiple fileupload related code

  openFileDialog() {
    $("#uploadImage").trigger("click");
  }

  // azure issue check
  /**
   * sets src of image for preview
   */
  getImageSrc() {
    if (this.uploadedImg) {
      return this.uploadedImg;
    } else if (this.imgBlock.assetId) {
      return `/api/Assets/Image/${this.imgBlock.assetId}`;
    }
    return "";
  }
  hotSpotUpdatedString(imgBlock: ImageBlock) {
    if (
      imgBlock.hotspotEditedHtmlString &&
      imgBlock.hotspotEditedHtmlString != ""
    ) {
      this.imgBlock.hotspotEditedHtmlString = imgBlock.hotspotEditedHtmlString;
      this.imgBlock.hotspotHtmlString = imgBlock.hotspotHtmlString;
    } else {
      this.imgBlock.hotspotEditedHtmlString = null;
      this.imgBlock.hotspotHtmlString = null;
    }
  }
  // Method to Add/Update imageBlock
  updateImageBlock() {
    if (this.imgBlock.hotspotEditedHtmlString == null) {
      this.imgBlock.hotspotHtmlString = null;
    }
    const imageObj = {
      id: null,
      playbookId: this.contentBlock.playbookId,
      assetId: this.imgBlock.assetId ? this.imgBlock.assetId : null,
      contentBlockId: this.contentBlock.id,
      caption: this.imgBlock.caption ? this.imgBlock.caption : null,
      hotspotEditedHtmlString: this.imgBlock.hotspotEditedHtmlString
        ? this.imgBlock.hotspotEditedHtmlString
        : null,
      enableImageAction: this.enlargeImage ? this.enlargeImage.value : false,
      hotspotHtmlString: this.imgBlock.hotspotHtmlString
        ? this.imgBlock.hotspotHtmlString
        : null,
      linkURL: this.linkUrl ? this.linkUrl.value : null,
      languageId: this.languageId,
      pageTemplateId: this.pageTemplateId,
      imageGroupId: !this.selectedImageGroup
        ? this.imgBlock.imageGroupId
          ? this.imgBlock.imageGroupId
          : null
        : this.selectedImageGroup.id,
    };

    if (this.imgBlock.id) {
      imageObj.id = this.imgBlock.id;
      this.commonHttpService
        .putWithHeaders(
          {
            uri: "/api/ImageBlocks/UpdateImageBlock",
            object: imageObj,
          },
          {
            pageId: this.pageId,
            sectionId: this.sectionId,
            playbookId: this.playbookId,
            languageId: this.languageId,
            isdraftmode: this.isdraftmode,
          }
        )
        .subscribe((res: ImageBlock) => {
          this.contentBlock.imageBlock = res;
          if (!this.openFromMobile) {
            this.modalRef.hide();
          } else {
            this.onclose.next(this.contentBlock);
          }
        });
    } else {
      this.commonHttpService
        .postWithHeaders(
          {
            uri: "/api/ImageBlocks/AddImageBlock",
            object: imageObj,
          },
          {
            pageId: this.pageId,
            sectionId: this.sectionId,
            playbookId: this.playbookId,
            languageId: this.languageId,
            isdraftmode: this.isdraftmode,
          }
        )
        .subscribe((res: ImageBlock) => {
          this.contentBlock.imageBlock = res;
          if (!this.openFromMobile) {
            this.modalRef.hide();
          } else {
            this.onclose.next(this.contentBlock);
          }
        });
    }
  }

  closeEditImageModal() {
    if (!this.openFromMobile) {
      this.modalRef.hide();
    } else {
      this.onclose.next(null);
    }
  }

  //#region methods to handle reordering of images in group
  slideshowInit() {
    if (this.imageGroupDetails.length > 0) {
      setTimeout(() => {
        const phElement = this.placeholder.element.nativeElement;
        phElement.style.display = "none";
        phElement.parentNode.removeChild(phElement);
      }, 1);
    }
  }
  drop() {
    if (!this.target) {
      return;
    }
    const phElement = this.placeholder.element.nativeElement;
    const parent = phElement.parentNode;

    phElement.style.display = "none";

    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(
      this.source.element.nativeElement,
      parent.children[this.sourceIndex]
    );

    this.target = null;
    this.source = null;
    if (this.sourceIndex !== this.targetIndex) {
      moveItemInArray(
        this.imageGroupDetails,
        this.sourceIndex,
        this.targetIndex
      );
      const orderObj = this.imageGroupDetails.map((image, index) => {
        return Object.assign({}, { id: image.id, order: index });
      });
      const reqObj = {
        playbookId: this.contentBlock.playbookId,
        imageGroupId: this.selectedImageGroup.id,
        languageId: this.languageId,
        orders: orderObj,
      };
      let imageGroupDetails = cloneDeep(
        this.selectedImageGroup.imageGroupDetail
      );
      forEach(this.imageGroupDetails, (cont: ImageGroupDetails, index) => {
        cont.order = index;
      });
      this.selectedImageGroup.imageGroupDetail = this.imageGroupDetails;
      const imageGroupIndex = this.findImageGroupIndex(
        this.items,
        this.selectedImageGroup.id
      );
      if (imageGroupIndex !== -1) {
        this.items[imageGroupIndex] = this.selectedImageGroup;
      }
      this.commonHttpService
        .postWithHeaders(
          {
            uri: "/api/ImageBlocks/ReorderGroupImages",
            object: reqObj,
          },
          {
            pageId: this.pageId,
            sectionId: this.sectionId,
            playbookId: this.playbookId,
            languageId: this.languageId,
            isdraftmode: this.isdraftmode,
          }
        )
        .subscribe(
          (res) => {
            imageGroupDetails = null;
          },
          (error) => {
            this.selectedImageGroup.imageGroupDetail = imageGroupDetails;
            this.imageGroupDetails = imageGroupDetails;
            const selectedImageGroupIndex = this.findImageGroupIndex(
              this.items,
              this.selectedImageGroup.id
            );
            if (selectedImageGroupIndex !== -1) {
              this.items[selectedImageGroupIndex] = this.selectedImageGroup;
            }
            imageGroupDetails = null;
          }
        );
    }
  }
  enter = (drag: CdkDrag, drop: CdkDropList) => {
    if (drop === this.placeholder) {
      return true;
    }
    const phElement = this.placeholder.element.nativeElement;
    const dropElement = drop.element.nativeElement;

    const dragIndex = __indexOf(
      dropElement.parentNode.children,
      drag.dropContainer.element.nativeElement
    );
    const dropIndex = __indexOf(dropElement.parentNode.children, dropElement);
    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      const sourceElement = this.source.element.nativeElement;
      phElement.style.width = sourceElement.clientWidth + "px";
      phElement.style.height = sourceElement.clientHeight + "px";

      sourceElement.parentNode.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = "";
    if (dropIndex === 0) {
      dropElement.parentNode.insertBefore(phElement, dropElement);
    } else {
      dropElement.parentNode.insertBefore(
        phElement,
        dragIndex < dropIndex ? dropElement.nextSibling : dropElement
      );
    }

    (this.source as any).start();

    (this.placeholder as any).enter(
      drag,
      drag.element.nativeElement.offsetLeft,
      drag.element.nativeElement.offsetTop
    );
    return false;
  };
  //#endregion
}

function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}
